import { render, staticRenderFns } from "./MenuModular.vue?vue&type=template&id=6e4a1f20&scoped=true&"
import script from "./MenuModular.vue?vue&type=script&lang=js&"
export * from "./MenuModular.vue?vue&type=script&lang=js&"
import style0 from "./MenuModular.vue?vue&type=style&index=0&id=6e4a1f20&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e4a1f20",
  null
  
)

export default component.exports